"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@mui/material/styles/styled"));
var reactstrap_1 = require("reactstrap");
var general_1 = require("utils/general");
var NavLink = (0, styled_1.default)(reactstrap_1.NavLink, { shouldForwardProp: (0, general_1.omitProps)('underlined') })(function (_a) {
    var _b;
    var theme = _a.theme, _c = _a.underlined, underlined = _c === void 0 ? true : _c;
    return ({
        '&.nav-link': {
            padding: theme.spacing(0.5, 2.5),
            fontSize: theme.typography.pxToRem(14),
            lineHeight: '1.5rem',
            borderRadius: theme.spacing(0.75),
            color: theme.palette.text.secondary,
            width: '100%',
        },
        '.svg-inline--fa': {
            fontSize: theme.typography.pxToRem(16),
            width: theme.spacing(2),
            marginRight: theme.spacing(1.5),
            verticalAlign: theme.spacing(-0.375),
            color: theme.palette.riverstone,
            ' .fa-secondary': { opacity: 1 },
        },
        ':focus-visible': __assign(__assign({}, theme.focusVisibleStyles), theme.focusVisibleLinkStyles),
        '&.active, :hover': {
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette.text.primary,
        },
        ':hover > .svg-inline--fa': {
            color: theme.palette.text.primary,
        },
        '&.nav-link.active': __assign(__assign({}, underlined && __assign(__assign({}, theme.primaryUnderline), { textUnderlineOffset: '2px' })), { '.svg-inline--fa': {
                color: theme.palette.text.primary,
            } }),
        '&.nav-link.disabled, &.nav-link.disabled > .svg-inline--fa': {
            color: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main,
        },
    });
});
exports.default = NavLink;
